<div class="back-button-container cursor-pointer" (click)="close.emit()">
  <button
    class="size-s with-bg back-button"
    [icon]="icon"
    alg-button-icon
  ></button>
  <p class="back-button-title alg-flex-1">
    <ng-content></ng-content>
  </p>
</div>
